export default "__VITE_ASSET__324e5f56__"